module.exports = __webpack_public_path__ + "29021af41c311e1d559fff526e140021.svg";